import { memo } from 'react';
import type { LucideIcon } from 'lucide-react';

interface KpiCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: LucideIcon;
  trend?: 'up' | 'down' | 'neutral';
}

export const KpiCard = memo(function KpiCard({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
}: KpiCardProps) {
  const trendColor =
    trend === 'up'
      ? 'text-status-success'
      : trend === 'down'
        ? 'text-status-error'
        : 'text-status-info';

  return (
    <div className="rounded-xl bg-white border border-brand-bake p-5 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-500 truncate">{title}</p>
          <p className="mt-2 text-3xl font-bold text-brand-caramel font-heading">
            {value}
          </p>
          {subtitle && (
            <p className={`mt-1 text-sm ${trendColor}`}>{subtitle}</p>
          )}
        </div>
        {Icon && (
          <div className="flex-shrink-0 ml-4 p-3 rounded-lg bg-brand-cream">
            <Icon className="h-6 w-6 text-brand-gold" />
          </div>
        )}
      </div>
    </div>
  );
});
